import { createSlice } from "@reduxjs/toolkit";

export const accountSlice = createSlice({
  name: "account",
  initialState: {
    id: "",
    shortcodes: [],
  },
  reducers: {
    applyAccount: (state, action) => {
      state.id = action.payload.account.accountId;
      state.shortcodes = action.payload.shortcodes;
    },
  },
});

export const { applyAccount } = accountSlice.actions;

export default accountSlice.reducer;
